const GENERIC_MESSAGE =
  "Sorry, something went wrong. Please try again later. If the problem persists, please get in touch with Earthly.";

export function getErrorMessage(error: unknown): string {
  if (typeof error === "string") return error;

  if (error instanceof Error) {
    return import.meta.env.MODE === "prod" ? GENERIC_MESSAGE : error.message;
  }

  return GENERIC_MESSAGE;
}

export default getErrorMessage;
